__turbopack_context__.v({
  "desktopMedia": "ThreeStepsSection-module__s3EfdW__desktopMedia",
  "heading": "ThreeStepsSection-module__s3EfdW__heading",
  "imageLayer": "ThreeStepsSection-module__s3EfdW__imageLayer",
  "inner": "ThreeStepsSection-module__s3EfdW__inner",
  "mobileDescription": "ThreeStepsSection-module__s3EfdW__mobileDescription",
  "mobileMedia": "ThreeStepsSection-module__s3EfdW__mobileMedia",
  "mobilePill": "ThreeStepsSection-module__s3EfdW__mobilePill",
  "mobilePillFill": "ThreeStepsSection-module__s3EfdW__mobilePillFill",
  "mobilePillLabel": "ThreeStepsSection-module__s3EfdW__mobilePillLabel",
  "mobilePillRow": "ThreeStepsSection-module__s3EfdW__mobilePillRow",
  "progressFill": "ThreeStepsSection-module__s3EfdW__progressFill",
  "progressTrack": "ThreeStepsSection-module__s3EfdW__progressTrack",
  "section": "ThreeStepsSection-module__s3EfdW__section",
  "stepContent": "ThreeStepsSection-module__s3EfdW__stepContent",
  "stepDescription": "ThreeStepsSection-module__s3EfdW__stepDescription",
  "stepImage": "ThreeStepsSection-module__s3EfdW__stepImage",
  "stepRow": "ThreeStepsSection-module__s3EfdW__stepRow",
  "stepTitle": "ThreeStepsSection-module__s3EfdW__stepTitle",
  "stepsColumn": "ThreeStepsSection-module__s3EfdW__stepsColumn",
});
